export default [
  {
    header: '—— การเงิน ——',
    resource: 'normal',
    action: 'manage',
  },
  {
    title: 'แจ้งชำระเงิน',
    route: 'finance-transfer',
    icon: 'CreditCardIcon',
    resource: 'high1',
    action: 'manage',
  },
  // {
  //   title: 'ฝากจ่าย/โอนเงินจีน',
  //   route: 'flash-china-payment',
  //   icon: 'CreditCardIcon',
  //   resource: 'high1',
  //   action: 'manage',
  // },
  // {
  //   title: 'แจ้งร้านจีนคืนเงิน',
  //   route: 'finance-refund',
  //   icon: 'CreditCardIcon',
  //   resource: 'high1',
  //   action: 'manage',
  // },
  // {
  //   title: 'วิธีแจ้งชำระเงินจีน',
  //   route: 'inform-payment',
  //   icon: 'BookOpenIcon',
  //   resource: 'high1',
  //   action: 'manage',
  // },
  {
    title: 'รายการ Balance',
    route: 'finance-balance',
    icon: 'BriefcaseIcon',
    resource: 'normal',
    action: 'manage',
  },
  // {
  //   title: 'ถอนเงิน',
  //   route: 'finance-withdraw',
  //   icon: 'HomeIcon',
  //   resource: 'high2',
  //   action: 'manage',
  // },
]
